import { render, staticRenderFns } from "./CallReceptionStatus.vue?vue&type=template&id=0da742ca&scoped=true"
import script from "./CallReceptionStatus.vue?vue&type=script&lang=ts"
export * from "./CallReceptionStatus.vue?vue&type=script&lang=ts"
import style0 from "./CallReceptionStatus.vue?vue&type=style&index=0&id=0da742ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da742ca",
  null
  
)

export default component.exports